import React, { createContext, useContext, useState, useCallback } from 'react';

const TranslateContext = createContext();

const MAX_HISTORY = 30;
const STORAGE_KEY = 'lingua_translate_history';

function loadHistory() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch { return []; }
}

export function TranslateProvider({ children }) {
  const [text, setText] = useState('');
  const [sourceLang, setSourceLang] = useState('en');
  const [targetLang, setTargetLang] = useState('fi');
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState(loadHistory);

  const saveToHistory = useCallback((inputText, sourceL, targetL, data) => {
    const entry = {
      id: Date.now(),
      text: inputText,
      sourceLang: sourceL,
      targetLang: targetL,
      translated_text: data.translated_text,
      vocabulary: data.vocabulary || [],
      timestamp: new Date().toISOString(),
    };
    setHistory(prev => {
      const updated = [entry, ...prev].slice(0, MAX_HISTORY);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const loadFromHistory = useCallback((entry) => {
    setText(entry.text);
    setSourceLang(entry.sourceLang);
    setTargetLang(entry.targetLang);
    setResult({ translated_text: entry.translated_text, vocabulary: entry.vocabulary });
  }, []);

  const deleteFromHistory = useCallback((id) => {
    setHistory(prev => {
      const updated = prev.filter(e => e.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearHistory = useCallback(() => {
    setHistory([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return (
    <TranslateContext.Provider value={{
      text, setText,
      sourceLang, setSourceLang,
      targetLang, setTargetLang,
      result, setResult,
      history, saveToHistory, loadFromHistory, clearHistory, deleteFromHistory,
    }}>
      {children}
    </TranslateContext.Provider>
  );
}

export const useTranslate = () => useContext(TranslateContext);